import "./WarningDialog.css";

const WarningDialog = ({
  resourceName,
  resourceId,
  onHandleDelete,
  onHandleClose,
}: {
  resourceName: string;
  resourceId: number;
  onHandleDelete: Function;
  onHandleClose: Function;
}) => {
  return (
    <div className="Warning__background" onClick={() => onHandleClose()}>
      <div
        className="Warning__container"
        onClick={(e: any) => e.stopPropagation()}
      >
        <h2>Deleting {resourceName}</h2>
        <p>Are you sure you want to delete {resourceName}?</p>
        <div className="Warning__actions">
          <button onClick={() => onHandleClose()}>Cancel</button>
          <button
            onClick={() => {
              onHandleDelete(resourceId);
              onHandleClose();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningDialog;
